<template>
  <ion-page>
    <Background></Background>
    <FabColumn>
      <BackButton :back_url="back_url"></BackButton>
    </FabColumn>
    <SidebarBackground></SidebarBackground>
    <WhiteBackground half="true"></WhiteBackground>
    <ion-content class="sidebar-content">
      <AboutContent :data="data"></AboutContent>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import SidebarBackground from "../components/common/SidebarBackground";
import AboutContent from "../components/about/AboutContent";
import BackButton from "../components/common/BackButton";
import common from "../common";

export default {
  name: "About",
  components: {
    BackButton,
    AboutContent,
    SidebarBackground,
    WhiteBackground,
    Background,
    IonPage,
    IonContent,
  },
  ionViewWillEnter() {
    this.back_url = this.$route.params.back_url;
    common.getStorage('about_data').then((value) => {
      this.data = value;

      if (value === null) {
        common.apiGetData('/about').then(res => {
          if (res === false) {
            return false;
          }
          common.setStorage('about_data', res.data);
          this.data = res.data;
        })
      }
    })
  },
  data() {
    return {
      data: [],
      back_url: '',
    }
  },
}
</script>

<style scoped>

</style>
